<template>
  <v-container
    d-flex
    align-content-center
    fill-height
    fluid
    style="height: 100vh"
    class="pt-0"
  >
    <v-row justify="center">
      <v-col cols="12" sm="12" md="auto" class="pa-4" style="max-width: 100%">
        <metrics-and-alerts
          :node="node"
          @confirm="$emit('close')"
          @cancel="$emit('close')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MetricsAndAlerts from './Overlay/MetricsAndAlerts.vue';

export default {
  components: {
    MetricsAndAlerts,
  },
  props: {
    node: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style></style>
